const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/actions/case.ts';
import { ILoadCasesMeta, LOAD_CASES } from '@cistec/common_web/actions/casesActions';
import { createPatapiCall, HttpMethod } from 'App/utils/fetchUtils';

export function loadCases(patnr: string, storeFullRecords?: boolean) {
    const meta: ILoadCasesMeta = {
        patnr,
        storeFullRecords,
        showDlgWhenResultHasMoreRows: true,
    };
    const endpoint = `cases`;
    return createPatapiCall(LOAD_CASES, endpoint, HttpMethod.GET, meta);
}
